// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".stamp[data-v-263a2e0b]{align-items:center;-webkit-backdrop-filter:brightness(.5);backdrop-filter:brightness(.5);background-color:rgba(32,32,29,.5);display:flex;height:100%;justify-content:center;left:0;position:absolute;top:0;width:100%}@media(max-width:985px){.stamp>img[data-v-263a2e0b]{height:118px;width:126px}}@media(min-width:986px){.stamp>img[data-v-263a2e0b]{height:177px;width:189px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
